import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccordionV2 from '../../layout/AccordionV2';

const PermissionSubCategoryAccordion = ({
  title,
  count,
  total,
  children,
}: {
  title: ReactNode;
  count: number;
  total: number;
  children: ReactNode;
}) => (
  <AccordionV2
    title={(
      <Box display="flex" justifyContent="space-between" width="100%">
        <Typography>
          {title}
        </Typography>
        <Typography>
          {count}
          {' '}
          /
          {' '}
          {total}
        </Typography>
      </Box>
    )}
  >
    {children}
  </AccordionV2>
);

export default React.memo(PermissionSubCategoryAccordion);
